<div class="zero-results-search__banner" *ngIf="!isQueryOutOfScope">
  <mm-icon name="magnifier-zero-results" [isCurrentColor]="false"></mm-icon>
  <ng-container *ngIf="hasFilters; else fullZRP">
    <div class="zero-results-search__banner-texts">
      <h2 class="zero-result-container__text__title">{{ zeroResultInfo?.title | translate }}</h2>
      <h3 class="zero-result-container__text__subtitle">{{ zeroResultInfo?.subTitle | translate }}</h3>
    </div>
  </ng-container>
  <ng-template #fullZRP>
    <div class="zero-results-search__banner-texts">
      <h2>
        <ng-container *ngIf="!!searchTerm">{{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.SEARCH.MAIN_TITLE' | translate: {searchTerm: searchTerm} }}</ng-container>
        <ng-container *ngIf="!searchTerm">{{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.SEARCH.NO_TERM_TITLE' | translate: {searchTerm: searchTerm} }}</ng-container>
      </h2>
      <h3>
        {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.TRIED_THESE' | translate }}
      </h3>
      <p>
        {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.SEARCH.SPELLING' | translate }}
      </p>
      <p>
        {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.GENERAL_TERM' | translate }}
      </p>
      <p>
        {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.SYNONYMS' | translate }}
      </p>
    </div>
  </ng-template>
</div>
<div *ngIf="isQueryOutOfScope" class="out-of-scope__banner" appIsVisible (isVisible)="onOutOfScopeBannerIsVisible()">
  <mm-icon name="zero-results-out-of-scope-box" [isCurrentColor]="false"></mm-icon>
  <div class="out-of-scope__banner-texts">
    <h2>
      {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.OUT_OF_SCOPE.MAIN_TITLE' | translate: {query: '"' + searchTerm + '"'} }}
      {{ 'CORE.ALL_PAGES.HEADER_TOPBUCKET.BUTTON1.TEXT' | translate }}
    </h2>
    <span class="out-of-scope__banner-bucket-link">
      {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.OUT_OF_SCOPE.DELIVERY_SERVICE_LINK_SEARCH' | translate }}
      <span
        class="out-of-scope__banner-bucket-link-searchquery"
        (click)="redirectToOtherBucket(eOtherBuckets.DeliveryService, searchTerm)"
      >{{ searchTerm }}</span
      >
      {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.OUT_OF_SCOPE.DELIVERY_SERVICE_LINK_IN' | translate }}
      {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.OUT_OF_SCOPE.DELIVERY_SERVICE_LINK_OUR' | translate }}
      <span class="out-of-scope__banner-bucket-link-bold">
        {{ bucketTitles[eOtherBuckets.DeliveryService] | translate }}
      </span>
    </span>
  </div>
</div>
<div class="zero-results-search__content">
  <ng-container>
    <ng-container *ngIf="isQueryOutOfScope && (isOutOfScopeCategoryGridEnabled$ | async)">
      <app-out-of-scope-category-grid
        [isMobile]="isMobile"
        [cards]="countryCategoriesCard"
        appIsVisible
        (isVisible)="onOutOfScopeCategoryGridIsVisible()"
      ></app-out-of-scope-category-grid>
    </ng-container>
    <div
      *ngIf="shouldShowAlternativeProductsCarousel"
      class="zero-results-search__block"
      [ngClass]="{ 'zero-results-search__block-padding-newStyle': (isNewPLPVariantRestyle$ | async) && isPLP }"
    >
      <div [ngClass]="{ zrp_carousel_title: (isNewPLPVariantRestyle$ | async) && isPLP }">
        <h3>
          {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.ALTERNATIVE_PRODUCTS.TITLE' | translate }}
        </h3>
      </div>
      <app-product-carousel
        [isMobile]="isMobile"
        [isDesktop]="isDesktop"
        [products]="recommendedProductsFromSearchResponse"
        [noBorder]="true"
        (productClicked)="onProductClick($event, 'alternative products')"
        appIsVisible
        (isVisible)="onCarouselIsVisible('alternative products', recommendedProductsFromSearchResponse)"
      >
      </app-product-carousel>
    </div>
    <ng-container *ngIf="recommendedProducts$ | async as recommendedProducts">
      <div
        *ngIf="recommendedProducts && recommendedProducts.length"
        class="zero-results-search__block"
        [ngClass]="{ 'zero-results-search__block-padding-newStyle': (isNewPLPVariantRestyle$ | async) && isPLP }"
      >
        <div [ngClass]="{ zrp_carousel_title: (isNewPLPVariantRestyle$ | async) && isPLP }">
          <h3>
            {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.RECOMMENDED_PRODUCTS.TITLE' | translate }}
          </h3>
        </div>
        <app-product-carousel
          appIsVisible
          [isMobile]="isMobile"
          [isDesktop]="isDesktop"
          [products]="recommendedProducts"
          [noBorder]="true"
          (productClicked)="onProductClick($event, recommendationServiceUsed)"
          (isVisible)="onCarouselIsVisible(recommendationServiceUsed, recommendedProducts)"
        >
        </app-product-carousel>
      </div>
    </ng-container>
    <ng-container *ngIf="popularProducts$ | async as popularProducts">
      <div
        *ngIf="popularProducts && popularProducts.length"
        class="zero-results-search__block"
        [ngClass]="{ 'zero-results-search__block-padding-newStyle': (isNewPLPVariantRestyle$ | async) && isPLP }"
      >
        <div [ngClass]="{ zrp_carousel_title: (isNewPLPVariantRestyle$ | async) && isPLP }">
          <h3>
            {{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.POPULAR_PRODUCTS.TITLE' | translate }}
          </h3>
        </div>
        <app-product-carousel
          appIsVisible
          [isMobile]="isMobile"
          [isDesktop]="isDesktop"
          [products]="popularProducts"
          [noBorder]="true"
          (productClicked)="onProductClick($event, 'popular products')"
          (isVisible)="onCarouselIsVisible('popular products', popularProducts)"
        >
        </app-product-carousel>
      </div>
    </ng-container>
    <div
      class="zero-results-search__block"
      [ngClass]="{ 'zero-results-search__block-padding-newStyle': (isNewPLPVariantRestyle$ | async) && isPLP }"
    >
      <app-category-carousel
        appIsVisible
        title="{{ 'CATALOG.CATALOG_PAGE.ZERO_RESULT.CATEGORIES_TITLE' | translate }}"
        [limit]="15"
        [promotion]="false"
        [isZeroResultsPage]="true"
        [searchTerm]="searchTerm"
        (isVisible)="onCategoriesCarouselIsVisible('categories')"
      ></app-category-carousel>
    </div>
    <app-other-buckets-banner
      appIsVisible
      [searchQuery]="searchTerm"
      [isZeroResult]="true"
      (isVisible)="onOtherBucketsBannerIsVisible()"
    >
    </app-other-buckets-banner>
  </ng-container>
</div>
